import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MyFeedbackHrOneOnOnePage from './pages/MyFeedbackHrOneOnOnePage';
import MyFeedbackHrOneOnOneDetailPage from './pages/MyFeedbackHrOneOnOneDetailPage';

const MyFeedbackHrOneOnOneModule: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<MyFeedbackHrOneOnOnePage />} />
      <Route path="/:applicationId" element={<MyFeedbackHrOneOnOneDetailPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default MyFeedbackHrOneOnOneModule;
